import { useCallback, useEffect, useState } from 'react';
import Context from 'managers/Context';

export function useCountryOptions() {
    const [countryOptions, setCountryOptions] = useState([]);
    const [countriesRaw, setCountriesRaw] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const loadCountries = useCallback(() => {
        setIsLoading(true);
        return Context.serverListManager
            .getList('tblCountries')
            .then((list = []) => {
                setCountriesRaw(list);
                setCountryOptions(
                    list.map((item) => ({
                        label: item.label,
                        value: String(item.value),
                    })),
                );
                return list;
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        loadCountries();
    }, [loadCountries]);

    return {
        countryOptions,
        countriesRaw,
        isLoadingCountries: isLoading,
        reloadCountries: loadCountries,
    };
}
